import { render } from "./Configuration.vue?vue&type=template&id=f3f5a2f0"
import script from "./Configuration.vue?vue&type=script&lang=ts"
export * from "./Configuration.vue?vue&type=script&lang=ts"
script.render = render

export default script